// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZT7oc{max-width:100%;padding:0 10px 20px 10px}.Y1YZt>div{min-width:100%}`, "",{"version":3,"sources":["webpack://./src/pages/instamart/home/components/PerformanceSummary/PerformanceSummary.module.scss"],"names":[],"mappings":"AAAA,OACI,cAAA,CACA,wBAAA,CAGJ,WACI,cAAA","sourcesContent":[".table {\n    max-width: 100%;\n    padding: 0 10px 20px 10px;\n}\n\n.wrapper > div {\n    min-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `ZT7oc`,
	"wrapper": `Y1YZt`
};
export default ___CSS_LOADER_EXPORT___;
